import store from "@/store";
import PassThrough from "../../views/pass-through.vue";
import tradingForumNewThread from "../../views/trading-forum/new-thread.vue";
import tradingForumCreateNewThread from "../../views/trading-forum/create-new-thread.vue";
import tradingForumViewThread from "../../views/trading-forum/view-thread.vue";
import {
  ROLE_ADMIN,
  LAYOUT_ADMIN
} from "../../constants";

const ifAuthenticated = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    let user = JSON.parse(localStorage.getItem("user"));
    let allowed = 0;
    for (let i = 0; i < to.meta.permission.length; i++) {
      if (to.meta.permission[i] === user.accessLevel) {
        allowed = 1;
        next();
        return;
      }
    }
    if (allowed === 0) {
      next("/not-allowed");
      return;
    }
  }
  next("/sign-in");
};

const tradingForumRouter = {
  path: "/trading-forum",
  component: PassThrough,
  meta: {
    layout: LAYOUT_ADMIN,
    permission: [
      ROLE_ADMIN,
    ],
  },
  children: [
    {
      path: "new-thread",
      name: "New Thread",
      component: tradingForumNewThread,
      beforeEnter: ifAuthenticated,
      meta: {
        layout: LAYOUT_ADMIN,
        permission: [
          ROLE_ADMIN,
        ],
        title: "Trading Forum",
        subtitles: [""]
      },
      props: true
    },
    {
      path: "create-new-thread",
      name: "Create New Thread",
      component: tradingForumCreateNewThread,
      beforeEnter: ifAuthenticated,
      meta: {
        layout: LAYOUT_ADMIN,
        permission: [
          ROLE_ADMIN,
        ],
        title: "Trading Forum",
        subtitles: [""]
      },
    },
    {
      path: "view-thread/:id",
      name: "View Thread",
      component: tradingForumViewThread,
      beforeEnter: ifAuthenticated,
      meta: {
        layout: LAYOUT_ADMIN,
        permission: [
          ROLE_ADMIN,
        ],
        title: "Trading Forum",
        subtitles: [""]
      },
      props: true
    },
  ],
  beforeEnter: ifAuthenticated
};

export default tradingForumRouter;
